
export enum FrequenciaTrabalho {
  Integral = 'Integral',
  MeioPeriodo = 'MeioPeriodo',
  FimDeSemana = 'FimDeSemana',
}
